import { ElementViewTemplate, html, repeat } from '@microsoft/fast-element';
import { NatGenPalette } from './palette';

export function paletteTemplate<T extends NatGenPalette>(): ElementViewTemplate<T> {
    return html<T>`
        <template>
            ${repeat(x => x.palette, html<string>`
                <div>
                    <span class="swatch" style="background-color: ${x => x[1]};"></span>
                    <span>${x => x[1]} - ${x => x[0]} </span>
                </div>
            `)}
        </template>
    `;
}
